import { render } from "./PairsVue.vue?vue&type=template&id=470dcf5d&scoped=true"
import script from "./PairsVue.vue?vue&type=script&lang=js"
export * from "./PairsVue.vue?vue&type=script&lang=js"

import "./PairsVue.vue?vue&type=style&index=0&id=470dcf5d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470dcf5d"]])

export default __exports__